<template>
  <!-- «Что нового» в кабинете ClipCut (V2T-42 · M2). Записи — src/data/whatsNew.json. -->
  <div class="modal-backdrop fade show" v-if="state.open" @click.self="close"></div>
  <div class="modal d-block" tabindex="-1" v-if="state.open" @click.self="close">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content whats-new-modal">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-stars me-2"></i>
            {{ $t('whats_new.title') }}
          </h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <div v-for="entry in entries" :key="entry.id" class="wn-entry">
            <div class="wn-date">
              {{ formatDate(entry.date) }}
              <span v-if="entry.draft" class="badge bg-warning text-dark ms-1">draft</span>
            </div>
            <div class="wn-title">{{ entry.title }}</div>
            <div class="wn-text" v-if="entry.text">{{ entry.text }}</div>
          </div>
          <div v-if="!entries.length" class="text-muted">{{ $t('whats_new.empty') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { whatsNewState, whatsNewEntries } from '@/lib/whatsNew';

export default {
  name: 'WhatsNewModal',
  data() {
    return { state: whatsNewState };
  },
  computed: {
    ...mapGetters('app', ['configData']),
    entries() {
      return whatsNewEntries(this.configData, this.$i18n.locale);
    }
  },
  methods: {
    close() {
      this.state.open = false;
    },
    formatDate(date) {
      const d = new Date(date + 'T00:00:00');
      if (isNaN(d)) return date;
      return d.toLocaleDateString(this.$i18n.locale, { day: 'numeric', month: 'long', year: 'numeric' });
    }
  }
};
</script>

<style scoped>
.whats-new-modal {
  background: var(--yt-bg-card, #fff);
  color: var(--yt-text-primary, #333);
}
.wn-entry {
  padding: 12px 0;
  border-bottom: 1px solid var(--yt-border-color, rgba(0, 0, 0, 0.08));
}
.wn-entry:last-child { border-bottom: none; }
.wn-date {
  font-size: 0.78rem;
  color: var(--yt-text-secondary, #6c757d);
  margin-bottom: 4px;
}
.wn-title {
  font-weight: 600;
  margin-bottom: 4px;
}
.wn-text {
  font-size: 0.9rem;
  line-height: 1.45;
  white-space: pre-line;
}
</style>
